<template>
  <v-container>
    <v-row no-gutters align="center" justify="center">
      <v-col cols="12" class="d-flex justify-center">
        <v-sheet width="400">
          <v-img @contextmenu.prevent clas :src="this.resultCode == '00' ? image_success : image_failed" width="400" />

          <div v-if="this.resultCode == '00'">
            <p class="text-h5 font-weight-bold text-center">
              {{ $t("cart-detail.payment-status.success") }}
            </p>

            <p class="text-body-2 font-weight-medium text-center">
              {{ $t("cart-detail.payment-status.success-message") }}
            </p>
          </div>

          <div v-else-if="this.resultCode == '02'">
            <p class="text-h5 font-weight-bold text-center">
              {{ $t("cart-detail.payment-status.expired") }}
            </p>

            <p class="text-body-2 font-weight-medium text-center">
              {{ $t("cart-detail.payment-status.expired-message") }}
            </p>
          </div>

          <p class="text-h6 font-weight-bold text-center my-4">
            {{ $t("cart-detail.payment-status.save-message") }}
          </p>

          <p class="text-body-1 font-weight-bold text-center text-red my-4">
            {{ $t("cart-detail.payment-status.transaction-id") }} {{ transactionId }}
          </p>

          <div class="d-flex justify-center my-1">
            <v-btn class="text-none" color="widget-color" @click="reloadPage()">{{ $t("cart-detail.payment-status.next")
              }}</v-btn>
          </div>

          <!-- <p class="text-body-2 font-weight-medium text-center">
            {{ $t("cart-detail.payment-status.message") }}
          </p>
          <p class="text-h6 font-weight-black text-center mt-2">
            {{ time_output }}
          </p> -->

          <v-divider class="border-opacity-50 mt-4" thickness="2"></v-divider>

          <card-footer></card-footer>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CardFooter from "@/components/footer/CardFooter.vue";
import IMAGE_SUCCESS from "@/assets/ilustration_success.svg";
import IMAGE_FAILED from "@/assets/ilustration_failed.svg";
export default {
  props: ["resultCode"],

  components: {
    CardFooter,
  },

  data() {
    return {
      time: null,
      time_output: null,
      image_success: IMAGE_SUCCESS,
      image_failed: IMAGE_FAILED,
    };
  },

  computed: {
    transactionId() {
      return this.$store.state.transactionId;
    },
  },

  created() {
    this.time = 5000;
  },

  methods: {
    reloadPage() {
      window.location.reload();
    },
    countdown() {
      if (this.time > 0) {
        setTimeout(() => {
          let time_final = this.time / 1000;
          this.time_output = this.$t(
            "cart-detail.payment-status.countdown",
            time_final,
            { n: time_final }
          );
          this.time -= 1000;
        }, 1000);
      } else {
        window.location.reload();
      }
    },
  },

  mounted() {
    // setInterval(() => {
    //   this.countdown();
    // }, 1000);
  },
};
</script>